interface LoadingProps {
  /** Fill the content area instead of the viewport — for boundaries that sit
   *  inside the app shell, where min-h-screen would push the layout. */
  contained?: boolean;
}

export default function Loading({ contained = false }: LoadingProps) {
  return (
    <div
      className={`flex items-center justify-center ${contained ? 'min-h-[40vh]' : 'min-h-screen'}`}
      role="status"
      aria-busy="true"
    >
      <div
        className="animate-spin h-12 w-12 border-b-2 border-primary-600"
        style={{borderRadius: "var(--border-radius-full)"}}
        aria-hidden="true"
      ></div>
    </div>
  );
}
